import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import "../styles/Welcome.css";

const Welcome = () => {
    const navigate = useNavigate();

    return (
        <motion.div
            className="welcome-section"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
        >
            <motion.div
                className="welcome-content"
                initial={{ y: 50 }}
                animate={{ y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
            >
                <h1 className="welcome-title">
                    Welcome to <span className="highlight">Your</span> Poster Generator!
                </h1>
                <p className="welcome-text">
                    Create stunning, professional posters in minutes with our AI-powered generator.
                    Whether you're promoting an event, designing for social media, or crafting
                    marketing materials, our intelligent system helps you create eye-catching
                    designs with ease. No design experience needed!
                </p>
                <motion.button
                    className="try-now-button"
                    onClick={() => navigate('/home')}
                    whileHover={{ scale: 1.05, backgroundColor: "#66D2CE" }}
                    whileTap={{ scale: 0.95 }}
                >
                    Try Now
                </motion.button>
            </motion.div>
        </motion.div>
    );
};

export default Welcome;